import React from "react";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/styles";
import { toJS } from "mobx";
import { withAlert } from "react-alert";

import tableIcons from "../../components/TableIcon";
import MaterialTable from "material-table";
import server from "../../stores/serverStore";
import user from "../../stores/userStore";
import location from "../../stores/locationStore";
import {
  makeStyles,
  Button,
  FormControlLabel,
  Switch,
  Badge,
  Typography,
} from "@material-ui/core";

import { Link } from "react-router-dom";
import SettingsApplicationsIcon from "@material-ui/icons/SettingsApplications";
import HistoryIcon from "@material-ui/icons/History";
import Moment from "moment";

import { URL } from "../../constant";
import krLoacale from "date-fns/locale/ko";
// const styles = (theme) => ({
//   tableContainer: {
//     marginTop: 20,
//   },
//   contracttalbe: {
//     width: 1600,
//   },
// });

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiPaper-root": {
      width: "100px",
    },
  },
}));

const View = observer(
  class List extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        checked: false,
        charge: toJS(user.charge) ? true : false,
      };
    }
    handleSwitch = (e) => {
      this.setState({
        [e.target.name]: e.target.checked,
      });
      if (e.target.name == "charge") {
        user.setCharge(e.target.checked);
      }
    };

    componentDidMount = async () => {
      await server.getServerList();
      await location.getLocationList();
    };

    render() {
      const { classes } = this.props;
      const list = toJS(server.serverList).sort(function (a, b) {
        return a.locname < b.locname ? -1 : a.locname > b.locname ? 1 : 0;
      });
      const USER = toJS(user.user);
      const isLoading = list.length > 0 ? false : true;
      const locationList = new Array();

      toJS(location.locationList).filter((item) => {
        if (item["detail"]["담당"] == USER.username) {
          locationList.push(item["locname"]);
        }
      });
      const serverList = this.state.charge
        ? list.filter((item) => locationList.includes(item.locname))
        : list;
      const isDirect = this.state.checked;
      const serverCol = [
        {
          title: "기관명",
          field: "locname",
          cellStyle: {
            textAlign: "center",
          },
          editable: "onAdd",
          render: (rowData) => (
            <p style={{ textAlign: "left" }}>
              <Link
                to={"/location/" + rowData["locname"]}
                style={{ textDecoration: "none" }}
              >
                <Button color="primary">{rowData["locname"]}</Button>
              </Link>
            </p>
          ),
        },
        {
          title: "서버구분",
          field: "gubun",
          cellStyle: {
            textAlign: "left",
          },
          render: (rowData) => <p>{rowData["gubun"]}</p>,
        },
        {
          title: "모델",
          field: "model",
          cellStyle: {
            textAlign: "left",
          },
          render: (rowData) => <p>{rowData["model"]}</p>,
        },
        {
          title: "설치일자",
          field: "installDate",
          type: isDirect ? "" : "date",
          cellStyle: {
            textAlign: "left",
          },
          render: (rowData) => (
            <p>
              {rowData["installDate"] &&
                Moment(rowData["installDate"]).format("YYYY-MM-DD")}
            </p>
          ),
        },
        {
          title: "OS",
          field: "os",
          cellStyle: {
            textAlign: "left",
          },
          render: (rowData) => <p>{rowData["os"]}</p>,
        },
        {
          title: "DB",
          field: "db",
          cellStyle: {
            textAlign: "left",
          },
          render: (rowData) => <p>{rowData["db"]}</p>,
        },
        {
          title: "History",
          field: "",
          editable: "never",
          cellStyle: {
            textAlign: "left",
          },
          render: (rowData) => (
            <Link
              to={"/history/" + rowData["locname"]}
              style={{ textDecoration: "none" }}
            >
              <Button
                variant="contained"
                color="primary"
                startIcon={<HistoryIcon />}
              >
                Histroy
              </Button>
            </Link>
          ),
        },
      ];

      return (
        <div>
          <Typography>
            전체 기관 수 : {toJS(location.locationList).length}
            <br />
            전체 서버 대수 : {list.length}
          </Typography>
          <FormControlLabel
            control={
              <Switch
                checked={this.state.checked}
                onChange={this.handleSwitch}
                name="checked"
                color="primary"
              />
            }
            label="날짜 직접 입력"
          />
          <FormControlLabel
            control={
              <Switch
                checked={this.state.charge}
                onChange={this.handleSwitch}
                name="charge"
                color="primary"
              />
            }
            label="내 담당만 보기"
          />
          <MaterialTable
            isLoading={isLoading}
            localization={{
              header: {
                actions: "수정",
              },
              toolbar: {
                exportTitle: "내보내기",
                exportAriaLabel: "라벨",
                searchPlaceholder: "검색",
                searchTooltip: "검색",
                exportName: "엑셀로 내보내기",
                exportCSVName: "엑셀로 내보내기",
              },
              body: {
                editRow: {
                  deleteText: "복구는 불가능 합니다. 삭제하시겠습니까?",
                },
                editTooltip: "수정",
                deleteTooltip: "삭제",
                addTooltip: "추가",
                dateTimePickerLocalization: krLoacale,
              },
            }}
            options={{
              exportButton: { csv: true },
              sorting: true,
              addRowPosition: "first",
              exportCsv: () => {
                const link = document.createElement("a");
                link.href = URL + "/servers/excel";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              },
              exportPdf: () => {
                this.props.alert.show(
                  "작업중입니다. csv파일 내보내기를 이용해주세요."
                );
              },
              headerStyle: { textAlign: "left", width: "100" },
            }}
            style={{}}
            icons={tableIcons}
            title={"기관별 서버현황"}
            columns={serverCol}
            data={serverList}
            editable={{
              onRowUpdate: (newData, oldData) =>
                new Promise((resolve) => {
                  (async () => {
                    try {
                      await server.updateServer(newData, USER);
                      resolve();
                    } catch (e) {
                      this.props.alert.show(
                        e.message +
                          "현재 존재하는 기관이 아닙니다. 관리자에게 문의해주세요."
                      );
                      resolve();
                    }
                  })();
                }),
              onRowAdd: (newData, oldData) =>
                new Promise((resolve) => {
                  (async () => {
                    try {
                      let response = await server.addServer(newData, USER);
                      resolve();
                    } catch (e) {
                      this.props.alert.show(
                        e.message + " 기관을 먼저 생성해주세요."
                      );
                      resolve();
                    }
                  })();
                }),
              onRowDelete: (newData, oldData) =>
                new Promise((resolve) => {
                  (async () => {
                    try {
                      let response = await server.deleteServer(newData, USER);
                      resolve();
                    } catch (e) {
                      resolve();
                    }
                  })();
                }),
            }}
          />
        </div>
      );
    }
  }
);

const alertView = withAlert()(View);
export default alertView;
